import React from "react";
import {Form} from "antd";
import TranslationInput from "../../../../shared/input/TranslationInput";
import Utils from "../../../../../utils";
import LocaleText from "../../../settings/dictionary/LocaleText";
import FieldPicker from "../../../../shared/pickers/FieldPicker";
import IContentType from "../../../../../model/interface/dataStorage/IContentType";
import ITabOptions from "../../../../../model/interface/widget/option/ITabOptions";

interface IProps {
    options: ITabOptions
    contentType?: IContentType
}

class TabWidgetEditor extends React.Component<IProps> {


    render() {
        const {contentType} = this.props
        return (
            <>
                <Form.Item name={'label'} label={'Zvolte nazev'} rules={[{required: true}]}>
                    <TranslationInput code={'configuration.widget.tab.' + Utils.uuid()} preserveCode={true}/>
                </Form.Item>
                {contentType && (
                    <Form.Item help={<LocaleText code={'configuration.widget.tab.alert-change-fields.help'} fallback={'Zde se zobrazí pole, u kterého jste v nastavení polí zaškrtli „zahrnout pole do seznamu změn záznamu“.'}/>} name={'alertChangeFields'} label={<LocaleText code={'configuration.widget.tab.alert-change-fields'} fallback={'Upozornění na změněná pole'}/>}>
                        <FieldPicker multiple={true} output={'name'} serviceClassName={contentType.fullClassName} includedInChangeList={true}/>
                    </Form.Item>
                )}
            </>


        )
    }
}

export default TabWidgetEditor